export const style = {
  tableBox: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '15px',
    borderBottom: '1px solid  #E9E9F4',
  },
  tableSubTotal: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#53575D',
    lineHeight: 'normal',
    paddingBottom: '6px',
    marginLeft: '14px',
  },
  tableDesign: {
    width: '100%',
  },
  tableBody: {
    background: 'transparent',
    border: 'none',
  },
  it: {
    '&.MuiTableCell-root': {
      borderBottom: '1px solid  #E9E9F4',
      padding: '12px',
      fontSize: '14px',
      fontWeight: '500',
      color: '#242528',
      textAlign: 'left',
    },
    '&.MuiPaper-root-MuiTableContainer-root': {
      backgroundColor: 'red',
      borderBottom: '1px solid  #E9E9F4',
    },
  },
  heading: {
    '&.MuiTableCell-root': {
      padding: '12px',
      fontSize: { xs: '14px', md: '16px' },
      fontWeight: '600',
      color: '#242528',
      textAlign: 'left',
    },
    '&.MuiPaper-root-MuiTableContainer-root': {
      backgroundColor: 'red',
      borderBottom: '1px solid  #E9E9F4',
    },
  },
  finalHeading: {
    '&.MuiTableCell-root': {
      padding: '12px',
      fontSize: { xs: '14px', md: '16px' },
      fontWeight: '600',
      color: '#242528',
      textAlign: 'right',
    },
    '&.MuiPaper-root-MuiTableContainer-root': {
      backgroundColor: 'red',
      borderBottom: '1px solid  #E9E9F4',
    },
  },
  tableRow: {
    '&.MuiTableRow-root': {
      borderBottom: '1px solid  #E9E9F4',
    },
  },
  list: {
    fontSize: '14px',
    color: '#242528',
    verticalAlign: 'top',
    paddingLeft: '13px',
    width: '60%',
    '&.MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  secondLi: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#242528',
    verticalAlign: 'top',
    paddingLeft: '22px',
    width: '70%',
  },
  lastCell: {
    color: '#53575D',
    borderBottom: '1px solid  #E9E9F4',
    padding: '12px 16px 12px 12px ',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'end',
  },
  li: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#242528',
    textAlign: 'end',
    verticalAlign: 'top',
  },
  qtyli: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#242528',
    verticalAlign: 'top',
    marginRight: '10px',
    '&.MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  secondCell: {
    borderBottom: '1px solid  #E9E9F4',
    padding: '12px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#242528',
    textAlign: 'center',
  },
  item: {
    fontWeight: 400,
    maxWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    '@media only screen and (min-width: 370px)': {
      maxWidth: '145px',
    },
    '@media only screen and (min-width: 450px)': {
      maxWidth: '200px',
    },
    '@media only screen and (min-width: 600px)': {
      maxWidth: '310px',
    },
  },
  checkoutItem: {
    fontWeight: 400,
    fontSize: '14px',
    color: '#242528',
    maxWidth: '120px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',

    '@media only screen and (min-width: 370px)': {
      maxWidth: '145px',
    },
    '@media only screen and (min-width: 450px)': {
      maxWidth: '200px',
    },
    '@media only screen and (min-width: 600px)': {
      maxWidth: '310px',
    },
  },
  modContainer: {
    marginLeft: '10px',
  },
  modifier: {
    color: '#53575Ded',
    fontSize: '12px',
    ml: '15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '110px',
    '@media only screen and (min-width: 370px)': {
      maxWidth: '140px',
    },
    '@media only screen and (min-width: 450px)': {
      maxWidth: '180px',
    },
    '@media only screen and (min-width: 600px)': {
      maxWidth: '220px',
    },
    '@media only screen and (min-width: 900px)': {
      maxWidth: '160px',
    },
    '@media only screen and (min-width: 1400px)': {
      maxWidth: '180px',
    },
  },
  specialRequest: {
    color: '#53575Ded',
    fontSize: '12px',
    ml: '10px',
    maxWidth: '150px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    '@media only screen and (min-width: 370px)': {
      maxWidth: '140px',
    },
    '@media only screen and (min-width: 450px)': {
      maxWidth: '160px',
    },
    '@media only screen and (min-width: 600px)': {
      maxWidth: '250px',
    },
    '@media only screen and (min-width: 1000px)': {
      maxWidth: '400px',
    },
  },

  afterDefaultPizzaSide: {
    ml: '10px',
  },
  modifierBold: {
    fontWeight: 400,
    fontSize: '12px',
    ml: '10px',
    color: '#53575Ded',
  },

  qty: {
    color: '#53575D',
    fontSize: '12px',
  },
  unit: {
    color: '#53575D',
    fontSize: '12px',
    textAlign: 'end',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',
    '&.MuiTableCell-root': {
      borderBottom: 'none',
    },
  },

  modifier1: {
    mt: '6px',
    ml: '15px',
    color: '#53575D',
    fontSize: '12px',
  },
};
